<template lang="pug">
button.dropdown.custom-btn-adding(:class="{open:isDropdownOpened}" @click.prevent='openDropdown' :style="select ? 'text-align: left;' : ''")
  div.dropdown-toggle(data-toggle="dropdown")
    img.icon-add(src='../../assets/images/faces/ic_add_24px.svg' v-if='!select')
    span(:style="select ? 'margin-left: 0' : ''") {{ selectedValue }}
    .material-icons(v-if="select") signal_cellular_4_bar
    ul.dropdown-menu.custom-dropdown-menu
      li.li-custom-add(v-for="r in links")
        a.dropdown-item.custom-dropdown-item(href="" @click="changeValue(r.code)") {{ r.name }}
</template>
<script>
import $ from 'jquery'
export default {
  props: {
    id: String,
    isSelected: Boolean,
    objSelected: Object
  },
  data() {
    return {
      isDropdownOpened: false,
      links: [
        { code: 3, name: 'Giáo viên', class: '.rel-change' },
        { code: 1, name: 'Bạn bè', class: '.rel-change' },
        { code: 2, name: 'Bạn đồng hành', class: '.rel-change' }
      ],
      selectedValue: 'Thêm bạn',
      select: false
    }
  },
  methods: {
    openDropdown(event) {
      // this.isDropdownOpened = !this.isDropdownOpened
      var dropdown = $(event.target).closest('.custom-btn-adding')
      if (!dropdown.hasClass('open')) {
        $('.custom-btn-adding').removeClass('open')
        dropdown.addClass('open')
      } else {
        dropdown.removeClass('open')
      }
    },
    closeDropDown() {
      if (this.isDropdownOpened) this.isDropdownOpened = false
    },
    changeValue(code) {
      for (let i = 0; i < this.links.length; i++) {
        if (this.links[i].code === code) {
          this.selectedValue = self.links[i].name
          this.select = true
          break
        }
      }
      // TODO: Gửi request yêu cầu kết bạn
    }
  },
  mounted () {
    // console.log('===== mounted =====')
    if (this.objSelected && this.objSelected !== null) {
      this.changeValue(this.objSelected.type)
    }
  }
}
</script>
<style lang="scss">
.li-custom-add {
  text-transform: none;
}

.custom-btn-adding {
  background: #FBF4D2;
  box-shadow: none;
  color: #9F6A28;
  border: 1px solid #FBF4D2;
  cursor: pointer;
  border-radius: 5px;
  // text-align: center;
  height: 32px;
  margin-top: 10px;
  width: calc(100% - 15px);
  font-size: 12px;
  padding-left: 8px;
  &:hover {background: #f9eebb; color: #9F6A28;}
  .dropdown-toggle {
    span {margin-left: 10px;}
    img.icon-add {width: 20px !important; position: absolute; top: -21px; left: 10px; }
    .material-icons {
      transform: rotate(45deg);
      position: absolute;
      top: 7px;
      right: 5px;
      color: black;
      font-size: 10px;
    }
    .custom-dropdown-menu {
      min-width: 106px !important;
      padding: 0;
      .li-custom-add {
        a {margin: 0;}
        .custom-dropdown-item {
          padding: 10px 5px;
          // &:hover {background: #f9eebb;}
        }
      }
    }
  }
  // .span-custom-add {
  //   margin-left: -15px; 
  //   text-transform: none;
  // }
  
}
@media (max-width: 414px) {
  .custom-btn-adding {
    ul.dropdown-menu {
      // display: block;
    }
    .span-custom-add {
      margin-left: 0; 
      text-transform: none;
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// itemAdding.vue?3d5cfcaf